<template>

	<div class="portlet box purple" v-show="classLevel === 'Bercario' || classLevel === 'Infantil' || classLevel === 'Fundamental_1'">

		<div class="portlet-title">

			<div class="caption">
				<i class="fa fa-paint-brush" aria-hidden="true"></i>
				<span v-translate>Atividades</span>
			</div>

		</div>

		<div class="portlet-body">

			<div class="table-responsible" v-if="activities && activities.lenght > 0">

				<table class="table table-striped table-bordered table-hover m-b-0">
					<thead>
						<tr>
							<th v-translate>Atividade</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="(activity, index) in activities">
							<th>{{ activity.activity }}</th>
						</tr>
					</tbody>
				</table>

			</div>

			<div>

				<p v-translate>Classifique a participatividade do aluno na aula hoje:</p>

				<div class="mt-radio-inline">

					<label v-for="(value, key) in ParticipationType" class="mt-radio mt-radio-outline m-b-0">

						<input type="radio" name="Participation" :value="key" :checked="key === participation" @change="putAgendaParticipation">
						{{ value }}
						<span></span>

					</label>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

	import StudentActivities from './';
	export default StudentActivities;

</script>



// WEBPACK FOOTER //
// activities.vue?4fe2ac0f